exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "titus-scaling-policy-summary .alarm-name {\n  word-break: break-all;\n}\ntitus-scaling-policy-summary .actions {\n  font-size: 85%;\n  margin: 0 0 15px 0;\n  border-bottom: 1px solid var(--color-alto);\n}\ntitus-scaling-policy-summary .actions .btn-left {\n  padding-left: 0;\n  border-left-width: 0;\n}\n", ""]);

